import Vue from 'vue'
import Router from 'vue-router'
import index from '@/views/index'
import aboutus from '@/views/aboutus/aboutus'  //指向folder下的.vue文件
import relation from '@/views/relation/relation'
import ability from '@/views/ability/ability'
import rescuelist from '@/views/rescuelist/rescuelist'  //指向folder下的.vue文件
import rescuedetail from '@/views/rescuelist/rescuedetail'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'index',
      component: index
    },
    {
      path: '/aboutus',
      name: 'aboutus',
      component: aboutus
    },
    {
      path: '/rescuelist',
      name: 'rescuelist',
      component: rescuelist
    },
    {
      path: '/relation',
      name: 'relation',
      component: relation
    },
    {
      path: '/ability',
      name: 'ability',
      component: ability
    },
    {
      path: '/rescuedetail',
      name: 'rescuedetail',
      component: rescuedetail
    }
  ],
  scrollBehavior(to, from, saveTop){
    if (saveTop) {
      return saveTop;
    } else {
      return {x: 0, y: 0}
    }
  }
})



// WEBPACK FOOTER //
// ./src/router/index.js